export function getFamilyIfManyTags({ tagsSubset, allTags }) {
  if (tagsSubset.length > 7) {
    const parentIds = tagsSubset.map(tag => tag.parent);

    const uniqueParentIds = new Set(parentIds);

    const parentTags = allTags.filter(tag => uniqueParentIds.has(tag.id));

    return parentTags;
  }

  return tagsSubset;
}
